<template>
    <section
        class="section-module office-manager-booking-module"
        :class="classname !== undefined ? classname : ''"
    >
        <!-- Loading -->
        <loading />

        <div class="module-content">
            <!-- Booking Content -->
            <div v-if="weekDayBookingOrder.length > 0" class="base-content">
                <!-- Booking List -->
                <template v-if="!showpdpbooking">
                    <div
                        v-if="routeisadminbooking"
                        class="icon-text-wrapper mb-tablet-only"
                    >
                        <p
                            @click="showSidebarMenu()"
                            role="button"
                            class="button-body"
                        >
                            Dashboard
                        </p>
                    </div>

                    <!-- Booking Title -->
                    <h1 class="title-content heading-4">Reservas</h1>

                    <div
                        v-for="(value, index) in weekDayBookingOrder"
                        :key="index"
                        class="d-flex flex-column booking-content"
                    >
                        <template
                            v-if="
                                value[Object.keys(value).join('')].date !== null
                            "
                        >
                            <p class="subtitle-content">
                                {{
                                    `${setPortugueseWekDayName(
                                        Object.keys(value).join("")
                                    )}, ${
                                        value[Object.keys(value).join("")].date
                                    }`
                                }}
                            </p>
                        </template>

                        <template v-else>
                            <p class="subtitle-content">
                                {{
                                    `${setPortugueseWekDayName(
                                        Object.keys(value).join("")
                                    )} `
                                }}
                            </p>
                        </template>

                        <div
                            v-if="
                                Array.isArray(
                                    value[Object.keys(value).join('')].data
                                ) &&
                                value[Object.keys(value).join('')].data.length >
                                    0
                            "
                            class="booking-base"
                            aria-describedby="Booking Card"
                        >
                            <div
                                v-for="(valbook, indexboook) in value[
                                    Object.keys(value).join('')
                                ].data"
                                :key="indexboook"
                                class="booking-card d-flex flex-column justify-content-start"
                                :data-indexrefer="indexboook"
                                :data-weekday="Object.keys(value).join('')"
                                :data-hasfeedback="valbook.has_feedback"
                                data-notify="2"
                                @click="showBookingDetails($event)"
                            >
                                <p class="card-title heading-6">
                                    {{ valbook.office_name }}
                                </p>

                                <div class="card-booking-info">
                                    <p>
                                        {{
                                            `${
                                                valbook.day
                                            } de ${valbook.month_name.toLowerCase()}`
                                        }}
                                    </p>
                                    <p class="">
                                        {{
                                            `${valbook.turndata.begin}:00 - ${valbook.turndata.end}:00`
                                        }}
                                    </p>
                                </div>

                                <div class="card-user-info">
                                    <p>{{ `${valbook.professional_name}` }}</p>
                                    <p class="caption-lg">
                                        {{ `${valbook.professional_email}` }}
                                    </p>
                                    <p
                                        v-if="
                                            valbook.professional_cellphone !==
                                            null
                                        "
                                        class="caption-lg"
                                    >
                                        {{
                                            `${valbook.professional_cellphone}`
                                        }}
                                    </p>
                                </div>

                                <template v-if="valbook.has_feedback">
                                    <small class="caption-lg"
                                        >*Esta reserva tem pedidos
                                        especiais</small
                                    >
                                </template>
                            </div>
                        </div>

                        <div v-else class="booking-base">
                            <p class="no-booking">
                                Não tem reservas para este dia
                            </p>
                        </div>
                    </div>
                </template>

                <!-- Pdp Booking -->
                <template v-else>
                    <div
                        class="d-flex flex-column booking-pdp"
                        ref="pdpbooking"
                    >
                        <!-- First Content -->
                        <div
                            class="icon-text-wrapper mb-tablet-only icon-text-wrapper-weekly"
                        >
                            <p
                                @click="turnBack()"
                                role="button"
                                class="turnback"
                            >
                                Reservas
                            </p>
                        </div>

                        <!-- Second Content -->
                        <div class="second-content">
                            <h4>{{ pdpbookingdata.office_name }}</h4>
                        </div>

                        <!-- Third Content -->
                        <div class="third-content">
                            <p class="strong-600">Detalhes da reserva:</p>

                            <div class="third-content-info">
                                <p>{{ pdpbookingdata.booking_date }}</p>
                                <p class="">
                                    {{
                                        `${pdpbookingdata.booking_begin}:00-${pdpbookingdata.booking_end}:00`
                                    }}
                                </p>
                            </div>

                            <p class="third-content-info-total">
                                Total:
                                {{ `${pdpbookingdata.booking_totalhour} hora` }}
                            </p>
                        </div>

                        <!-- Fourty Content -->
                        <div v-if="hasfeedback" class="fourthy-content">
                            <div
                                v-for="(
                                    value, index
                                ) in pdpbookingdata.feedbackdata"
                                :key="index"
                                class="d-flex flex-column"
                            >
                                <div class="d-flex flex-column">
                                    <div
                                        class="d-flex flex-row justify-content-between"
                                    >
                                        <strong class="body-1 strong-600">{{
                                            value.data.subject === 1
                                                ? "Pedidos especiais"
                                                : "Cancelamento"
                                        }}</strong>
                                        <span
                                            :class="
                                                statusClassname(value.status)
                                            "
                                            class="body-1"
                                            >{{ value.status }}</span
                                        >
                                    </div>
                                    <p class="body-1 color-text-body">
                                        {{ value.data.message }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-else class="no-requests">
                            <p class="strong-600">Pedidos:</p>
                            <p class="color-text-body">Não há pedidos</p>
                        </div>

                        <!-- Fifthy Content -->
                        <div class="fifthy-content">
                            <p class="fifthy-content-title strong-600">
                                Detalhes do utilizador
                            </p>

                            <div class="fifthy-content-info d-flex flex-column">
                                <figure>
                                    <img
                                        :src="pdpbookingdata.professional_media"
                                        alt="User Image"
                                    />

                                    <figcaption>
                                        <p class="heading-6">
                                            {{
                                                pdpbookingdata.professional_name
                                            }}
                                        </p>

                                        <div class="desktop-flex">
                                            <a
                                                :href="`mailto:${pdpbookingdata.professional_email}`"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-describedby="Send Mail"
                                                class="email body-1"
                                                >{{
                                                    pdpbookingdata.professional_email
                                                }}</a
                                            >

                                            <a
                                                :href="`tel:+351${pdpbookingdata.professional_cellphone}`"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-describedby="Call User"
                                                class="phone body-1"
                                            >
                                                {{
                                                    pdpbookingdata.professional_cellphone
                                                }}
                                            </a>
                                        </div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div v-else>
                <div
                    v-if="routeisadminbooking"
                    class="icon-text-wrapper mb-tablet-only"
                >
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="button-body"
                    >
                        Dashboard
                    </p>
                </div>

                <h1 class="subtitle-content heading-5">
                    Sem reservas confirmadas para esta semana
                </h1>
            </div>
        </div>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>

<script>
import fetchData from "./../../../fetchData.js";
import Loading from "./../../elements/LoadingElement.vue";
import ListMessage from "./../../elements/ListMessageElement.vue";
import responseMessage from "./../../../responseMessage.js";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";

//Set Use Strict
("use strict");

export default {
    name: "BookingAdmin",
    props: {
        booking: {
            type: String,
            required: true,
        },
        notifyurl: {
            type: String,
            required: true,
        },
        csrftolken: {
            type: String,
            required: true,
        },
        classname: {
            type: String,
            required: false,
        },
        routeisadminbooking: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            activeclass: "d-flex",
            bookingdata: {},
            weekBooking: {},
            defaultWeekdays: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
            ],
            weekDayBookingOrder: [],
            weekdate: "",
            showpdpbooking: false,
            pdpbookingdata: {},
            dateclass: {},
            hasfeedback: true,
            responseTimeOut: 5000,
        };
    },
    created() {
        //Decode Data
        this.bookingdata = JSON.parse(this.booking);
    },
    mounted() {
        //Date Options
        /* const options = {
            weekday: "long",
            //year: "numeric",
            month: "long",
            day: "numeric",
        }; */

        //Set Date Class
        this.dateclass = new Date();

        //Get Data from Date
        const currentWeekday = this.dateclass.toLocaleDateString("en-EN", {
            weekday: "long",
        });

        //Get Week Booking
        this.getWeekBooking(currentWeekday, this.bookingdata);

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        statusClassname(statusvalue) {
            let semAcento = statusvalue
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            return semAcento.toLowerCase().replace(" ", "-");
        },
        showBookingDetails(element) {
            //Get Element
            let bookingData = element.currentTarget;

            //Set Has Feedback
            this.hasfeedback =
                bookingData.getAttribute("data-hasfeedback") === "false"
                    ? false
                    : true;

            //Get Feedback Data
            let weekdayBookingData = this.weekDayBookingOrder.find((value) =>
                Object.getOwnPropertyDescriptor(
                    value,
                    bookingData.getAttribute("data-weekday")
                )
            );

            //Get Booking Data
            let dataFromBooking =
                weekdayBookingData[bookingData.getAttribute("data-weekday")]
                    .data[bookingData.getAttribute("data-indexrefer")];

            //Set Pdp Booking Data
            this.pdpbookingdata.office_name = dataFromBooking.office_name;
            this.pdpbookingdata.office_id = dataFromBooking.office_id;
            this.pdpbookingdata.professional_id =
                dataFromBooking.professional_id;
            this.pdpbookingdata.professional_name =
                dataFromBooking.professional_name;
            this.pdpbookingdata.professional_email =
                dataFromBooking.professional_email;
            this.pdpbookingdata.professional_cellphone =
                dataFromBooking.professional_cellphone;
            this.pdpbookingdata.professional_media =
                dataFromBooking.professional_media;
            this.pdpbookingdata.booking_date = `${dataFromBooking.day}-${
                dataFromBooking.month_id
            }-${this.dateclass.getFullYear()}`;
            this.pdpbookingdata.booking_begin = dataFromBooking.turndata.begin;
            this.pdpbookingdata.booking_end = dataFromBooking.turndata.end;
            this.pdpbookingdata.booking_totalhour =
                dataFromBooking.turndata.totalhour;

            //HasFeedback
            if (!this.hasfeedback) {
                if (Object.hasOwn(this.pdpbookingdata, "feedbackdata")) {
                    delete this.pdpbookingdata.feedbackdata;
                }

                //Conditional for show Pdp Content
                this.showpdpbooking = true;

                return;
            }

            //Set Feedback Data
            this.pdpbookingdata.feedbackdata = [];

            dataFromBooking.feedbackdata.forEach((value) => {
                let request = {
                    data: value.data,
                    status: value.form_status,
                };

                this.pdpbookingdata.feedbackdata.push(request);
            });

            //Only Get Update Feedback
            this.pdpbookingdata.feedbackdata =
                this.pdpbookingdata.feedbackdata.filter((value) => {
                    if (
                        value.data.booking.begin ===
                            this.pdpbookingdata.booking_begin &&
                        value.data.booking.end ===
                            this.pdpbookingdata.booking_end &&
                        value.data.booking.day === dataFromBooking.day
                    ) {
                        return value;
                    }
                });

            //Conditional for show Pdp Content
            this.showpdpbooking = true;
        },
        turnBack() {
            //Conditional for show Pdp Content
            this.showpdpbooking = false;
        },
        getWeekBooking(weekday, booking) {
            //Check Booking
            if (booking.length === 0) {
                return this.weekDayBookingOrder;
            }

            //Get Weekday reference
            let weekdayreferindex = this.defaultWeekdays.indexOf(weekday);
            let weekdayrefer = [];

            for (let i = 0; i < this.defaultWeekdays.length; i++) {
                if (i >= weekdayreferindex) {
                    weekdayrefer.push(this.defaultWeekdays[i]);
                }
            }

            //Set Week Booking Data
            weekdayrefer.forEach((value) =>
                Object.defineProperty(this.weekBooking, value, {
                    value: booking[value],
                    writable: false,
                })
            );

            //Set Weekday Boking Order
            weekdayrefer.forEach((val) => {
                let weekdayobject = {};
                weekdayobject[val] = {
                    data: Object.hasOwn(booking, val)
                        ? this.weekBooking[val]
                        : null,
                    date: null,
                };

                //Check Booking Data
                if (weekdayobject[val].data !== null) {
                    weekdayobject[val].data.forEach((valdate) => {
                        weekdayobject[val].date = `${
                            valdate.day
                        } de ${valdate.month_name.toLowerCase()}`;
                        valdate.professional_cellphone =
                            valdate.professional_cellphone !== null
                                ? valdate.professional_cellphone
                                      .toString()
                                      .replace(" ", "")
                                      .trim()
                                : null;
                    });
                }

                this.weekDayBookingOrder.push(weekdayobject);
            });
        },
        setPortugueseWekDayName(weekday) {
            let weekdayname = "";

            switch (weekday) {
                //Monday
                case "Monday":
                    weekdayname = "Segunda-feira";

                    break;

                //Tuesday
                case "Tuesday":
                    weekdayname = "Terça-feira";

                    break;

                //Wednesday
                case "Wednesday":
                    weekdayname = "Quarta-feira";

                    break;

                //Thursday
                case "Thursday":
                    weekdayname = "Quinta-feira";

                    break;

                //Friday
                case "Friday":
                    weekdayname = "Sexta-feira";

                    break;

                //Saturday
                case "Saturday":
                    weekdayname = "Sábado";

                    break;

                //Sunday
                case "Sunday":
                    weekdayname = "Domingo";

                    break;
            }

            return weekdayname;
        },
        sendData() {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            let dataForm = {
                name: this.pdpbookingdata.professional_name,
                email: this.pdpbookingdata.professional_email,
                booking_date: this.pdpbookingdata.booking_date,
                booking: {
                    begin: this.pdpbookingdata.booking_begin,
                    end: this.pdpbookingdata.booking_end,
                },
            };

            //Send Data
            let response = fetchData.structureTosendData(
                this.notifyurl,
                dataForm,
                this.csrftolken,
                "PATCH"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    return;
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedWeekDate() {
            return this.weekdate;
        },
        computedShowPdpBooking() {
            return this.showpdpbooking;
        },
        computedPdpBooking() {
            return this.pdpbookingdata;
        },
        computedHasFeedback() {
            return this.hasfeedback;
        },
    },
    watch: {
        computedWeekDate() {},
        computedShowPdpBooking() {},
        computedPdpBooking() {},
        computedHasFeedback() {},
    },
    components: {
        loading: Loading,
        listMessage: ListMessage,
        cardElement: CardElement,
    },
};
</script>
